@let homeComponentData = (HomeComponentData$ | async);

<app-jjsv-loader [isLoading]="isLoading()" message="Loading dashboard..."></app-jjsv-loader>

<main class="home-page">

  <app-jjsv-banner [content]="{
    title: homeComponentData?.homePageTitle,
    subtitle: homeComponentData?.homePageDescription,
    imageUrl: homeComponentData?.homePageLogo?.url ? baseUrl + homeComponentData?.homePageLogo?.url : ''
  }"></app-jjsv-banner>
  
  <section class="home-page__section home-page__section--notifications" [attr.aria-label]="translations.notificationsLabel">
    <div class="home-page__container home-page__notifications">
      @for (item of homeComponentData?.notifications ; track item.title) {
        <app-jjsv-notification [content]="item"></app-jjsv-notification>
      }
    </div>
  </section>

  <section class="home-page__section home-page__section--tiles" [attr.aria-label]="translations.quickActionsLabel">
    <div class="home-page__container home-page__tiles">
      @for (item of homeComponentData?.tiles; track item.title) {
        <app-jjsv-tile
          [title]="item.title"
          [description]="item.description"
          [linkLabel]="item.linkLabel"
          [linkHref]="item.link"
          [isBordered]="item.isBordered"
          [orderType]="item.orderType"
          (linkClick)="onTileClick($event)"
        ></app-jjsv-tile>
      }
    </div>
  </section>

  @if (notificationMessage$ | async; as notificationMessage) {
    <section class="home-page__section home-page__section--notifications" [attr.aria-label]="translations.notificationsLabel">
      <div class="home-page__container home-page__notifications">
        <app-jjsv-notification class="message-{{ notificationMessage?.notificationStatus?.toLowerCase() }}" [content]="notificationMessage"></app-jjsv-notification>
      </div>
    </section>
  }

  <section class="home-page__section home-page__section--table" [attr.aria-label]="translations.ordersTableLabel">
    <div class="home-page__container home-page__table-wrap">

      <app-jjsv-table
        [columns]="tableColumns"
        [rows]="getDisplayRows(homeComponentData?.timeZone)"
        [isSorting]="false"
        [ariaLabel]="translations.purchaseOrdersTableAriaLabel"
        [emptyMessage]="translations.noOrdersFound"
      ></app-jjsv-table>

      @if(homeComponentData?.timeZone === 'PT') {
        <p class="home-page__table-note">{{ translations.timeNotePT }}</p>
      }@else if(homeComponentData?.timeZone === 'GMT') {
        <p class="home-page__table-note">{{ translations.timeNoteGMT }}</p>
      }@else {
        <p class="home-page__table-note">{{ translations.timeNote }}</p>
      }

      <div class="home-page__table-actions">
        <button type="button" class="home-page__table-button" (click)="refreshTableData()">
          {{ translations.refreshButtonLabel }}
          <span><img src="assets/svgs/refresh.svg" [alt]="translations.refreshIconAlt" height="15" width="15" /></span>
        </button>
      </div>
    </div>
  </section>
</main>